import { ApplicationConfig, inject, provideAppInitializer, provideZonelessChangeDetection, APP_ID } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { HttpClient, provideHttpClient, withXhr } from '@angular/common/http';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { LanguageService } from '@services/language.service';
import { ConfigurationService } from '@services/configuration.service';
import { routes } from './app.routes';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const configFactory = (configurationService: ConfigurationService) => {
  return () => configurationService.load();
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideHttpClient(withXhr()),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    { provide: APP_ID, useValue: 'my-app' },
    LanguageService,
    provideAppInitializer(() => {
      const initializerFn = configFactory(inject(ConfigurationService));
      return initializerFn();
    })
  ]
};
